import { ArrowRight, Loader2 } from "lucide-react";
import { useEffect } from "react";
import { money } from "../lib/api";
import { useBooking } from "../context/BookingContext";
import { useQuote } from "./ItinerarySidebar";

export const MobileBookBar = ({ label = "Continue", onClick, disabled, form, busy }) => {
  const { rate, criteria } = useBooking();
  const { data: q } = useQuote();
  const framed = window.self !== window.top;
  useEffect(() => {
    if (framed) return undefined;
    document.body.classList.add("has-book-bar");
    return () => { document.body.classList.remove("has-book-bar"); };
  }, [framed]);
  if (framed) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-brand/10 bg-sand/95 px-4 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-3 shadow-[0_-12px_30px_-18px_rgba(0,0,0,0.35)] backdrop-blur-xl lg:hidden" data-testid="mobile-book-bar">
      <div className="mx-auto flex max-w-xl items-center gap-3">
        <div className="min-w-0 flex-1">
          {q && rate ? (
            <>
              <p className="text-[11px] uppercase tracking-[0.18em] text-ink/50">Total · {criteria.nights} night{criteria.nights > 1 ? "s" : ""}</p>
              <p className="truncate font-mono text-lg text-ink" data-testid="mobile-book-bar-total">{money(q.total, q.currency)}</p>
            </>
          ) : (
            <p className="text-sm text-ink/60" data-testid="mobile-book-bar-hint">Choose a room and rate to continue</p>
          )}
        </div>
        <button type={form ? "submit" : "button"} form={form} onClick={onClick} disabled={disabled || busy}
          className="btn-primary shrink-0 !px-5 !py-2.5 disabled:opacity-40" data-testid="mobile-book-bar-continue">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}{label}{!busy && <ArrowRight className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
};
